<template>
  <common-dialog
    ref="dialog"
    :title="title"
    width="1100px"
    :in-dialog="inDialog"
  >
    <list
      ref="list"
      common
      :show-query="true"
      :show-checkbox="multiple"
      :is-show="true"
      :is_listDialog="true"
      :modelType="modelType"
      :isSelect="true"
    >
      <template #column>
        <slot name="column" />
        <template v-if="selectable && !multiple">
          <el-table-column label="操作" align="center" width="60" fixed="right">
            <template slot-scope="{ row }">
              <el-button
                :disabled="row.DistrictId == NoId"
                @click="onSelect(row)"
                type="text"
                >选择</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button
          type="primary"
          @click="selectMultiple"
          v-if="selectable && multiple"
          >选择</el-button
        >
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "销售订单列表",
    },
    modelType: {   
      type: String,
      default: "salessaleorder",
    },
  },
  data() {
    return {
      params: {},
      NoId: 0,
    };
  },

  methods: {
    selectMultiple() {
      console.log(this.$refs.list,'this.$refs.list')
      let TradeUnitId=0
      let FullName=''
      if(this.$refs.list.TradeUnitId>0) TradeUnitId=this.$refs.list.TradeUnitId
      if(this.$refs.list.FullName) FullName=this.$refs.list.FullName
      let data= {
        Order:this.$refs.list.OrderNo,
        List:this.$refs.list.subSelectList,
        TradeUnitId:TradeUnitId,
        FullName:FullName
      }
      this.$emit('select-multiple',data)
      this.close();
    },
    getData(params = {}) {
      // console.log('我执行到这');
      // this.NoId = params.NoId;
      // this.$refs.list.showTable(this.params);
      this.$refs.list.getData(params);
      // this.$refs.tree.getData();
    },
    // treeSelect(data) {
    //   this.$refs.list.showTable({ ...this.params, IdChain: data.IdChain });
    // },
    // titleClick() {
    //   this.$refs.list.showTable({ ...this.params, IdChain: null });
    // },
  },
};
</script>
